'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (root, factory) {
    if (typeof module !== 'undefined' && module.exports !== undefined) {
        module.exports = factory();
    } else if (typeof define !== 'undefined' && define.amd) {
        define('IAccount', [], function () {
            return factory();
        });
    } else {
        root.IAccount = factory();
    }
})(window || module || {}, function () {
    var formatters = {
        /**
         * For example, XXXX XXXX XXXX XXXX
         * @param {string}intStr
         * @param {string} splitter
         * @return {string}
         */
        full: function full(intStr) {
            var splitter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            return this._addSplitter(intStr, splitter);
        },

        card: function card(intStr) {
            var splitter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';

            return this._addSplitter(intStr, splitter);
        },

        /**
         * For example, XXXX **** **** XXXX
         * @param {string} intStr
         * @param {string} splitter
         * @return {string}
         */
        hidden: function hidden(intStr) {
            var splitter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '*';

            var hidden = '',
                i = void 0,
                start = void 0,
                tail = void 0;

            // too short number
            if (intStr.length <= this.countBeforeSplitter * 2) {
                i = 8;
                // rest of numbers
                tail = intStr.length > this.countBeforeSplitter ? intStr.substr((intStr.length - this.countBeforeSplitter) * -1) : '';
            } else {
                i = intStr.length - this.countBeforeSplitter * 2;
                tail = intStr.substr(this.countBeforeSplitter * -1);
            }

            while (i--) {
                hidden += '*';
            }

            start = intStr.substr(0, this.countBeforeSplitter);

            return this._addSplitter(start + hidden + tail, splitter);
        },

        /**
         * For example, ** XXXX
         * @param {string} intStr
         * @param {string} splitter
         * @return {string}
         */
        short: function short(intStr) {
            var splitter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '*';

            if (intStr.length < this.countBeforeSplitter * 2) {
                return splitter + ' ' + intStr.substr(this.countBeforeSplitter / 2 * -1);
            } else {
                return splitter + ' ' + intStr.substr(this.countBeforeSplitter * -1);
            }
        }
    };

    /**
     * @description Bank Accounts Parser, use:a = new IAccount('1234 12 34 12341234')
     * @constructor
     * @param {number|string} value
     * @return {object}
     */

    var IAccount = function () {
        function IAccount(value) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            _classCallCheck(this, IAccount);

            this.value = null;
            this.account = null;
            this.countBeforeSplitter = options.countBeforeSplitter || 4;

            if (!value) {
                return this;
            }

            if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value instanceof IAccount) {
                this.value = value.value;
            } else {
                if (typeof value === 'number') {
                    this.value = value.toString();
                } else if (typeof value === 'string') {
                    // for view number-account
                    var arr = value.split('-');
                    value = arr[0];

                    this.value = value.replace(/[^0-9]+/g, '') || this.value;
                    this.account = (arr[1] || '').replace(/[^0-9]+/g, '') || this.account;
                }
            }

            this.account = this.account || this.value;

            return this;
        }

        /**
         * @description Get string like '1234123412341234'
         * @param {string} format "full"|"short"
         * @param {string} splitter
         * @return {string}
         */


        _createClass(IAccount, [{
            key: 'toString',
            value: function toString() {
                var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'full';
                var splitter = arguments[1];

                var str = void 0;

                splitter = splitter === null ? '' : splitter;
                str = this.value || '';

                if (this.value) {
                    if (format === 'full') {
                        str = formatters.full.call(this, this.value, splitter);
                    } else if (format === 'short' && this.value) {
                        str = formatters.short.call(this, this.value, splitter);
                    } else if (format === 'hidden' && this.value) {
                        str = formatters.hidden.call(this, this.value, splitter);
                    } else if (format === 'card') {
                        str = formatters.card.call(this, this.value, splitter);
                    }
                }

                return str;
            }

            /**
             * @description Check on Luhn algorithm
             * @return {Boolean}
             */

        }, {
            key: 'isCard',
            value: function isCard() {
                return this.luhnValidate();
            }

            /**
             * check card's type on Visa
             * @return {Boolean}
             */

        }, {
            key: 'isVisa',
            value: function isVisa() {
                return !!(this.value && +this.value.substr(0, 1) === 4 && [13, 16, 17, 18, 19].indexOf(this.value.length) >= 0);
            }

            /**
             * check card's type on MasterCard
             * @return {Boolean}
             */

        }, {
            key: 'isMasterCard',
            value: function isMasterCard() {
                return !!(this.value && [5, 6].indexOf(+this.value.substr(0, 1)) >= 0 && this.value.length >= 16 && this.value.length <= 19);
            }

            /**
             * bank account matching
             * @return {Boolean}
             */

        }, {
            key: 'isAccount',
            value: function isAccount() {
                return this.value && this.value.length >= 6 && this.value.length <= 19;
            }

            /**
             * Check account
             * @param {string} format
             * @return {boolean}
             */

        }, {
            key: 'validate',
            value: function validate(format) {
                if (!this.value || this.value.length < 4) {
                    return false;
                }

                if (format === 'luhn') {
                    return this.isCard();
                } else {
                    /**
                     * If this is not a card and not Visa or Mastercard, detected as account
                     */
                    if (!this.isCard() && (this.isVisa() || this.isMasterCard()) && this.isAccount() || !this.isAccount()) {
                        return false;
                    }
                }

                return true;
            }

            /**
             *
             * @param {object} number
             * @return {Boolean}
             * @private
             */

        }, {
            key: 'luhnValidate',
            value: function luhnValidate() {
                var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.value;

                number = number || '';

                var len = number.length,
                    digit = parseInt(number.substring(len - 1, len)),
                    less = number.substring(0, len - 1);

                return this._luhnCalculate(less) === parseInt(digit);
            }

            /**
             * Javascript code copyright 2009 by Fiach Reid : www.webtropy.com
             * @param {string} str
             * @return {boolean}
             */

        }, {
            key: '_luhnCalculate',
            value: function _luhnCalculate() {
                var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                var sum = 0,
                    i = void 0,
                    mod = void 0,
                    deltaIndex = void 0,
                    delta = [0, 1, 2, 3, 4, -4, -3, -2, -1, 0];

                for (i = 0; i < str.length; i++) {
                    sum += parseInt(str.substring(i, i + 1));
                }
                for (i = str.length - 1; i >= 0; i -= 2) {
                    deltaIndex = parseInt(str.substring(i, i + 1));
                    sum += delta[deltaIndex];
                }
                mod = 10 - sum % 10;
                if (mod === 10) {
                    mod = 0;
                }
                return mod;
            }

            /**
             * add ' ' every [num] digits
             * @param {string} str
             * @param {string} splitter
             * @return {string}
             * @private
             */

        }, {
            key: '_addSplitter',
            value: function _addSplitter(str, splitter) {
                var arr = [];

                while (str.length) {
                    if (str.length > this.countBeforeSplitter) {
                        arr.push(str.substring(0, this.countBeforeSplitter));
                        str = str.substring(this.countBeforeSplitter);
                    } else {
                        arr.push(str.substring(0, str.length));
                        str = '';
                    }
                }

                return arr.join(splitter);
            }
        }, {
            key: 'toHtml',
            value: function toHtml() {
                var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'full';

                console.warn('IAccount.prototype.toHtml() is deprecated. Use .toString() wrapped by your own HTML tags.');
                return this.toString(format);
            }

            /**
             * Compare accounts. True if equal
             * @param {string} value
             * @return {Boolean}
             */

        }, {
            key: 'is',
            value: function is() {
                var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                console.warn('IAccount prototype.is() is deprecated.');

                var obj = new IAccount(value);

                return obj.value && obj.value === this.value && (!obj.account || !this.account || obj.account === this.account);
            }
        }, {
            key: 'toNumber',
            value: function toNumber() {
                console.warn('IAccount prototype.toNumber() is deprecated. Use .toString().');
                return this.toString.apply(this, arguments);
            }
        }, {
            key: 'isDefault',
            value: function isDefault() {
                console.warn('IAccount prototype.isDefault() is deprecated.');
                return false;
            }
        }]);

        return IAccount;
    }();

    return IAccount;
});